/**
 * 员工公共接口
 */
import { get } from '@/common/request/index';
/**
  * 查询员工
  * https://yapi.lanhanba.com/project/307/interface/api/33892
  */

export function getEmployee(params = {}) {
  return get('/employee/search', params, true);
}

